import { cn } from '@/lib/utils'

export function BaronMark({ className }: { className?: string }) {
  return (
    <svg className={cn('h-full w-full', className)} viewBox="0 0 46 40" aria-hidden>
      <rect width="46" height="40" rx="6" fill="#737373" />
      <path
        fill="white"
        d="M8 6h13.2C31.8 6 38 9.3 38 14.5c0 3.1-2.3 5.5-6.7 7 5.2 1.3 7.7 3.8 7.7 7.2C39 34.5 32.5 38 21.1 38H8v-5.5h13c6.7 0 10-1.4 10-4.3 0-2.7-3.7-4.2-11.1-4.2H8v-5h12c6.6 0 9.9-1.3 9.9-3.9 0-2.4-3.2-3.6-9.5-3.6H8V6Z"
      />
      <path
        fill="#737373"
        d="M8 11.5c8.9.4 16.1 3 21.8 7.7-7.2-2.1-14.5-2.2-21.8-.5v-7.2Z"
      />
      <path fill="#737373" d="M8 24c9 .3 16.7 3.1 23 8.3-7.7-2.4-15.4-2.6-23-.7V24Z" />
    </svg>
  )
}

export function BaronLockup({ className }: { className?: string }) {
  return (
    <div className={cn('flex items-center gap-3', className)}>
      <BaronMark className="h-10 w-11.5" />
      <span className="flex flex-col leading-none">
        <span className="text-xl font-bold tracking-tight">BARON</span>
        <span className="text-[11px] font-medium tracking-[0.34em] text-muted-foreground">
          WEATHER
        </span>
      </span>
    </div>
  )
}
